import path from 'node:path'
import type { RailwayDeployEnvVar } from '@cli-types/next-adapter/railway.js'
import { RAILWAY_ENV_SYNC_SKIP_KEYS } from '@cli-constants/env-sync.js'
import { parseDotenvFile } from '@cli-utils/files.js'
import { isPlaceholderValue } from '@next-adapter/init/scaffolders/env/is-placeholder-value.js'

export function collectRailwayDeployEnvVars(
  cwd: string,
  existingKeys: Set<string>,
  providerOverrides: Record<string, string>
): RailwayDeployEnvVar[] {
  const variables: RailwayDeployEnvVar[] = []
  const local = parseDotenvFile(path.join(cwd, '.env.local'))

  for (const [key, value] of local) {
    if (RAILWAY_ENV_SYNC_SKIP_KEYS.has(key) || !value || isPlaceholderValue(value)) continue
    if (key in providerOverrides) continue
    if (existingKeys.has(key)) continue
    variables.push({ key, value, overwrite: false })
  }

  for (const [key, value] of Object.entries(providerOverrides)) {
    variables.push({ key, value, overwrite: true })
  }

  return variables
}
